import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {Illustration} from 'shells/illustrations/illustration';
import {ImageWrapper} from 'shells/onboarding-modal/image-wrapper';
import {OnboardingModal} from 'shells/onboarding-modal/onboarding-modal';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

const pages = [
    {
        id: 'flexible',
        body: (
            <OnboardingBody title='Flexible widgets'>
                <p>
                    Your lead page is organized into widgets that you can hide, show, collapse and
                    reorder.
                </p>
                <p>
                    Customizations will be applied to your entire team, and can be different for
                    each lead pipeline.
                </p>
            </OnboardingBody>
        ),
        art: {
            background: colors.blueXlt,
            image: () => (
                <ImageWrapper image={<Illustration src='lead-customize-layout' />} width={300} />
            ),
        },
    },
    {
        id: 'custom',
        body: (
            <OnboardingBody title='Custom field widgets'>
                <p>
                    Use custom field widgets to show the right information for each pipeline. Choose
                    which custom fields belong in each widget. Create as many widgets as you need,
                    then add them to your main workspace or sidebar to tailor your experience.
                </p>
            </OnboardingBody>
        ),
        art: {
            background: colors.blueXlt,
            image: () => (
                <ImageWrapper
                    image={<Illustration src='lead-customize-layout-custom-widgets' />}
                    width={300}
                />
            ),
        },
    },
];

type Props = {
    setIsOpen: (isOpen: boolean) => void;
};

export function LearnMoreModal(props: Props) {
    return (
        <OnboardingModal
            onFinish={() => {
                props.setIsOpen(false);
            }}
            onClose={() => {
                props.setIsOpen(false);
            }}
            lastButtonText='Done'
            pages={pages}
            isOpen={true}
            maxHeight={586}
        />
    );
}
